import React from "react"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

// Custom Style
import loadingStyle from '../../styles/jss/components/loadingStyle'


const useStyle = makeStyles(loadingStyle)

const Loading = props => {
	const loadingClasses = useStyle()

	return (
		<div className={loadingClasses.loading}><CircularProgress size={50} thickness={5.0} /></div>
	)
}


export default Loading